import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';

export function getName() {
  return 'RSAAssetsGrid';
}

export function getColumnsMetadata() {
  return _.defaults({
    Asset: 'Asset/Text',
    AssetId: 'Asset/Id',
    AssetSource: 'Asset/AssetSource',
    AssetType: 'AssociationType',
    PinnedField: 'PinnedField',
    Status: 'UiDisplayStatus',
    AssetPerformanceLabel: 'PerformanceLabel',
    PolicyStatus: 'EditorialStatus',
  }, PerformanceMetricsColumns);
}

export function getRoute({
  AdId,
}) {
  return `customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/ad/${AdId}/assets`;
}
